import './dropDownArrow.css'

export default function DropDownArrow() {
    return(
        <div className="drop-down-arrow">
            <svg width="58.069" height="33.198" viewBox="0 0 58.069 33.198">
                <path id="Icon_ion-ios-arrow-back" data-name="Icon ion-ios-arrow-back" d="M21.258,35.221,43.23,13.266a4.15,4.15,0,0,0-5.878-5.86L12.459,32.282A4.142,4.142,0,0,0,12.338,38l25,25.049a4.15,4.15,0,1,0,5.878-5.86Z" transform="translate(-6.194 44.449) rotate(-90)" fill="#77b6db"/>
            </svg>
        </div>
    )
}